import { useEffect, useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Why from "../components/Why";
import Products from "../components/Products";
import B2B from "../components/B2B";
import Blog from "../components/Blog";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
import { WhatsAppFab } from "../components/Extras";
import { buildWhatsAppUrl } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
    const [products, setProducts] = useState([]);
    const [posts, setPosts] = useState([]);
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const [prodRes, cfgRes, blogRes] = await Promise.all([
                    axios.get(`${API}/products`),
                    axios.get(`${API}/config`),
                    axios.get(`${API}/blog`),
                ]);
                setProducts(prodRes.data);
                setConfig(cfgRes.data);
                setPosts(blogRes.data);
            } catch (e) {
                console.error("Error cargando datos", e);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    return (
        <div data-testid="lolopets-landing" className="min-h-screen bg-brand-cream">
            <Header />
            <main>
                <Hero config={config} />
                <Why />
                <Products products={products} config={config} loading={loading} />
                <B2B config={config} />
                <Blog posts={posts.length ? posts : undefined} />
                <Faq config={config} />
            </main>
            <Footer config={config} />
            <WhatsAppFab url={buildWhatsAppUrl(config?.whatsapp)} />
        </div>
    );
}
